export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};
export const ESCALATION_LEVELS = [
  { id: 1, text: "Level 1" },
  { id: 2, text: "Level 2" },
  { id: 3, text: "Level 3" },
  { id: 4, text: "Level 4" },
  { id: 5, text: "Level 5" },
];
